import Icon from '../components/Icon.vue'

Icon.register({
  info: {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M20 424.2h20v-144.5h-20c-11 0-20-9-20-20v-47.8c0-11 9-20 20-20h112c11 0 20 9 20 20v212.2h20c11 0 20 9 20 20v47.8c0 11-9 20-20 20h-152c-11 0-20-9-20-20v-47.8c0-11 9-20 20-20zM96 0c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/info.js
// module id = 1492
// module chunks = 0